/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FreshserviceTicketAttachment {
    getFixupPrototypeFunction() { return FreshserviceTicketAttachment.fixupPrototype; }

    static newInstance(model: Partial<FreshserviceTicketAttachment>): FreshserviceTicketAttachment {
        let obj = Object.assign(new FreshserviceTicketAttachment(), model);
        FreshserviceTicketAttachment.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FreshserviceTicketAttachment>): FreshserviceTicketAttachment {
        if (!model) return null;
        return FreshserviceTicketAttachment.newInstance(<FreshserviceTicketAttachment> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FreshserviceTicketAttachment) {
        if (!obj) return;

        models.FreshserviceTicketAttachment.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FreshserviceTicketAttachment): boolean {
        Object.setPrototypeOf(obj, FreshserviceTicketAttachment.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name
     */
    name: string;

    /**
     * Content Type
     */
    content_type: string;

    /**
     * Attachment Url
     */
    attachment_url: string;

}
